export enum Env {
  DEV = 'dev',
  TEST = 'test',
  PROD = 'prod'
}